import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Third Party Provider Appearance',
  attributeName: 'thirdPartyProviderAppearance',
  fields: [
    {
      attributeName: 'name',
      helpText: 'Displayed provider name to show in the app',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Display Name',
      placeholder: 'Display name...',
    },
    {
      attributeName: 'providerImage',
      helpText: 'Displayed provider image to show in the app',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Display Image',
      fileType: ['.png', '.jpg', 'jpeg'],
    },
    {
      attributeName: 'description',
      helpText: 'Displayed provider subtitle to show in the app',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Display Subtitle',
      placeholder: 'Display Subtitle...',
    },
    {
      attributeName: 'displayURL',
      helpText: 'Displayed provider URL to show in the app about third party external links',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Display URL',
      placeholder: 'Display URL...',
    },
  ],
};
